<template>
  <v-bottom-sheet v-model="sheet" inset width="500">
    <v-list class="pt-4 px-5 pb-16">
      <v-subheader class="font-weight-bold font-size--18 color--black">{{ title }}</v-subheader>
      <v-list-item-group mandatory v-model="selectedIdx">
        <v-list-item
          v-for="item in options"
          :key="item.value"
          @click="$emit('select', item.value)"
          color="white"
        >
          <template v-slot:default="{ active }">
            <v-list-item-title class="color--gray-60">{{ item.text }}</v-list-item-title>
            <v-list-item-icon>
              <v-icon v-if="active" color="black">mdi-check</v-icon>
            </v-list-item-icon>
          </template>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="px-2" id="no-background-hover" text color="black" v-on="on" v-bind="attrs">
        <p class="font--m-4 mb-0 ml-0">{{ showSelected }}</p>
        <v-icon> mdi-chevron-down </v-icon>
      </v-btn>
    </template>
  </v-bottom-sheet>
</template>

<script>
export default {
  props: ['title', 'options', 'initValue'], // [{text: '전체', value: 'all'}]
  data() {
    return {
      selectedIdx: this.initValue,
      sheet: false,
    }
  },
  watch: {
    selectedIdx() {
      this.sheet = !this.sheet
    },
  },
  computed: {
    showSelected() {
      return this.options[this.selectedIdx]?.text
    },
  },
}
</script>

<style lang="scss" scoped>
.v-bottom-sheet {
  .v-list {
    font-family: $font-family;
    border-radius: 16px 16px 0 0;

    .v-list-item {
      font-weight: 600;

      &:not(:last-child) {
        border-bottom: 1px solid $gray-30;
      }
    }

    .v-item--active {
      font-weight: bold;

      .v-list-item__title {
        color: black !important;
      }
    }
  }
}
</style>
